import React from "react";
import { ArrowPathIcon, EyeDropperIcon } from "@heroicons/react/24/outline";

const Field = React.memo(function Field({
  label,
  value,
  onChange,
  type = "text",
  icon = null,
  placeholder,
  colorFallback = "#3b82f6",
}) {
  const val = value ?? "";

  if (type === "color") {
    const id = `color-${label.replace(/\s+/g, "-").toLowerCase()}`;

    return (
      <div className="space-y-2">
        <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
          {icon ? <span className="w-4 h-4">{icon}</span> : null}
          {label}
        </label>

        <div className="flex items-center gap-2">
          <div className="relative">
            <input
              id={id}
              type="color"
              value={val || colorFallback}
              onChange={(e) => onChange(e.target.value)}
              className="sr-only"
            />
            <label
              htmlFor={id}
              className="block w-10 h-10 rounded-lg border-2 border-gray-200 cursor-pointer shadow-sm hover:shadow-md transition-shadow"
              style={{ backgroundColor: val || colorFallback }}
              title="Pick color"
            >
              <EyeDropperIcon className="w-5 h-5 m-2.5 text-white/80" />
            </label>
          </div>

          <div className="flex-1 flex items-center gap-2">
            <input
              type="text"
              value={val}
              onChange={(e) => onChange(e.target.value)}
              placeholder={placeholder || colorFallback}
              className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
            <button
              type="button"
              onClick={() => onChange("")}
              className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              title="Reset to default"
            >
              <ArrowPathIcon className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (type === "textarea") {
    return (
      <div className="space-y-2">
        <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
          {icon ? <span className="w-4 h-4">{icon}</span> : null}
          {label}
        </label>
        <textarea
          value={val}
          onChange={(e) => onChange(e.target.value)}
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
          rows={3}
          placeholder={placeholder}
        />
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
        {icon ? <span className="w-4 h-4">{icon}</span> : null}
        {label}
      </label>
      <input
        type={type}
        value={val}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        placeholder={placeholder}
      />
    </div>
  );
});

export default Field;
